module.exports = __webpack_public_path__ + "img/a3-s78.c7639e60.jpg";